/**
 * Formatting Utilities
 */

import { getConfig } from '../core/config';
import { CATALOG_UNIT_PRICE_FORMAT_OPTIONS } from '@shoppex/contracts/catalog-unit-price';

export function createFormatter(
  currency?: string,
  locale?: string
): Intl.NumberFormat {
  const config = getConfig();

  return new Intl.NumberFormat(locale ?? config.locale ?? 'en-US', {
    style: 'currency',
    currency: currency ?? config.currency ?? 'USD',
    ...CATALOG_UNIT_PRICE_FORMAT_OPTIONS,
  });
}

export function formatPrice(
  amount: number | string,
  currency?: string,
  locale?: string
): string {
  const numericAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
  if (Number.isNaN(numericAmount)) {
    return createFormatter(currency, locale).format(0);
  }
  return createFormatter(currency, locale).format(numericAmount);
}
